<template>
 
 <!-- style='width:800px'  -->
   <div class="function_wrap"   >
            <consult v-if="!isPhone"></consult>
            <div id='calbox' :class=" !isPhone? 'function_wrap box':'function_wrap box_mobile' "      >

   
                <h1 class="function_wrap_title">自定义利息计算器</h1>
                <div class="function_wrap_title_EN">INTEREST CALCULATOR</div>
                
       
                <div class='optionitem' :style="isPhone?'width:100%':'' ">   
                    <div class="optionitem item_name" >输入金额：</div>
                    <div class="optionitem item_detail"> <el-input type='number' min=0 v-model="inputValue" placeholder="请输入金额"></el-input> </div>
                    
                </div>  


                <div class='optionitem' :style="isPhone?'width:100%':'' ">   
                        <div class="optionitem item_name">时间：</div>
                      
                        <!-- <div  class="optionitem item_detail" >
    
                            <el-date-picker
                                v-model="date"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                style=" width:100% ">
                            </el-date-picker>
                        </div> -->


                    <div  class="optionitem item_detail" style="margin-left:0" >
                        <el-date-picker
                            v-model="date[0]"
                            align="right"
                            type="date"
                            placeholder="选择日期"
                            format='yyyy-MM-dd'
                            value-format='yyyy-MM-dd'
                        
                            >
                        </el-date-picker>
                        <span  :style="isPhone?'margin: 10px 10px ':'margin: 0 10px 0 10px' " >至</span>
             

                        <el-date-picker
                            v-model="date[1]"
                            type="date"
                      
                            format='yyyy-MM-dd'
                            value-format='yyyy-MM-dd'
                            placeholder="选择日期">
                        </el-date-picker>


 


                    </div>
        
                </div>  



                <div class='optionitem' :style="isPhone?'width:100%':'' ">   
                    <div class="optionitem item_name">计息方式：</div>
                    <div class="optionitem item_detail"> 
                        <!-- <el-radio v-model="ishalf" label="1" border>否</el-radio>
                        <el-radio v-model="ishalf" label="2" border>是</el-radio> -->
                        <el-radio-group v-model="ratio">
                            <el-radio :label="'日息'">日息</el-radio>
                            <el-radio :label="'月息'">月息</el-radio>
                            <el-radio :label="'年息'">年息</el-radio>
                        </el-radio-group>

                    </div>

                </div>  

                <div class='optionitem' :style="isPhone?'width:100%':'' ">   
                    <div class="optionitem item_name" >填写利息({{ratio}})：</div>
                    <div class="optionitem item_detail"> <el-input type='number' min=0 v-model="interest" placeholder="请输入利息（统一用小数表示,如月息0.012）"></el-input> </div>
                        
                </div> 

                <div class='optionitem' :style="isPhone?'width:100%':'' " >   
                    <div class="optionitem item_name">天数算法：</div>
                    <div class="optionitem item_detail"> 

                        <el-radio v-model="days_mode" label="mode_d1" border  :style="!isPhone?'':'margin:auto'" :size="isPhone? 'mini':'' " >算头不算尾</el-radio>
                        <el-radio v-model="days_mode" label="mode_d2" border   :style="!isPhone?'':'margin:auto'" :size="isPhone? 'mini':'' " >两头都算</el-radio>
                        
                  
                    
                    </div>

                </div> 

                <div v-if="ratio=='年息'" class='optionitem' :style="isPhone?'width:100%':'' " >   
                    <div class="optionitem item_name">年息天数基准：</div>
                    <div class="optionitem item_detail"> 

                        <el-radio v-model="method_year" label="360" border  :style="!isPhone?'':'margin:auto'" :size="isPhone? 'mini':'' " >360</el-radio>
                        <el-radio v-model="method_year" label="365" border   :style="!isPhone?'':'margin:auto'" :size="isPhone? 'mini':'' " >365</el-radio>
                        
                  
                    
                    </div>

                </div> 

                <div class="plus_box">
                    <div class='refund_box'>  
                        <!-- <span style="width:85%">多次还款记录(会员功能）：</span> -->
                        <div style="width:65%">  
                            <el-badge value="hot"  style="right:-10px"  >
                                <span title='解决中间夹杂付款或还款的场景，计算更加简单' >期间付款或还款记录(会员功能）：</span>
                            </el-badge>

                        </div>

 
                        <div  >
                            
                         
                            <router-link  to="/community/enk91631296197" target='_blank'  class="guide">   
                                使用说明

                            </router-link> 

                            <i  class="el-icon-circle-plus" style="font-size:24px;cursor:pointer;margin-top:5px;margin-right:10px" @click="AddLine"></i>  
                            
                          
                        </div>

                       
                    </div>

                    <div class='newline'   v-for="(item,index) of param.cond" v-bind:key="index">   
                        <div class="newline item_name" style="text-align:center">  还款日期: </div>

                        <el-date-picker
                            style="width:200px"
                            v-model="item.date" 
                            align="right"
                            type="date" 
                            placeholder="选择日期"
                            format='yyyy-MM-dd'
                            value-format='yyyy-MM-dd'
                            >
                        </el-date-picker>

                        <span  class="newline item_name"    style="text-align:center">还款金额：</span>
            

                        <el-input class="newline item_detail" type='number' min=0 v-model="item.amount" ></el-input> 

                        <i   class="el-icon-remove"  style="font-size:24px;cursor:pointer;margin-top:8px;margin-left:10px"  @click="RemoveLine(index)"></i>

                        <!-- <div  class="newline item_detail" style="margin-left:0" >
                            <el-date-picker
                                v-model="item.date"
                                align="right"
                                type="date"
                                placeholder="选择日期"
                                >
                            </el-date-picker>
                         

                        </div> -->
        
                    </div>  


                </div>

                <div class='optionitem' style="font-size:14px;text-align:left;margin-top:10px">(银行利息计算方式下，一般算头不算尾，是之前的默认方式。根据部分客户的需求，增加算头又算尾的方式。中间有还款的情况下，建议选择算头不算尾，两头都算会造成多计算重复天数利息。多次还款计算为非复利计算。)</div>



                <div  style="margin-top:60px">
                    <!-- <button @click="alert('ok')" type="button">Click Me!</button>
                    <button type="button">Cancle!</button> -->
                    <el-row>

                        <el-button @click="newcal" type="primary">确定</el-button>
                        <el-button @click="reset" type="warning" style="margin-left: 50px;">清空</el-button>
                
                    </el-row>
                </div>

       

        
                      


                <div class="result">
                    <h4>计算结果：</h4>
                    <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;初始本金： {{inputValue}}  </p>

                    <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;天数共计： {{s3}} 日</p>
                    <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;利息共计： {{isMuti=='yes' && (resArr[resArr.length-1].int_sum || resArr[resArr.length-1].int_sum==0)  ?  resArr[resArr.length-1].int_sum : result1}}     元</p>
                    <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;本息共计： {{isMuti=='yes' && (resArr[resArr.length-1].sum || resArr[resArr.length-1].int_sum==0) ?  resArr[resArr.length-1].sum : result2}}   元</p>
                    
                    <div  class='resultbox' v-if="isMuti=='no'"    decode="true"  style='min-height:40rpx;line-height:40rpx;margin-top:10rpx'  >
                        <p > 利息算法： {{ algorithm }}  </p> 
                    </div>


                    <div style="width:100%;margin:10px 0;">
                        <el-button type="primary" plain @click="bind_download">下载详情文档(中间有付款情况下，VIP专享)</el-button>
                    </div>

                    <div  v-for="(item,index) of resArr" v-bind:key="index"   class='resultbox' >   
                        <span  class='item_result' selectable decode="true"> 日期：{{index>0?  resArr[index-1].date :date[0]}}至 {{item.date}}   </span>
                        <span v-if="resArr.length>1" class='item_result' selectable decode="true">天数： {{ item.result.totalDays }}  </span>
                        <span v-if="resArr.length>1"  class='item_result' selectable decode="true"> 当前计算本金：{{item.ini_capital}}    </span>
                        <span v-if="resArr.length>1 && item.amount>0"  class='item_result' selectable decode="true"> 本期还款金额：{{item.amount}}    </span>
                        <span   class='item_result' selectable decode="true">期间利息： {{ item.int }}  元</span>
                        
                        <span  v-if="resArr.length>1  && item.amount>0 "  class='item_result' selectable decode="true">还款后剩余利息： {{ item.int_sum  }}  元</span>
                   
                        <span   class='item_result' selectable decode="true">本息结余： {{ item.sum  }}   元</span>
                        <span class='item_result' selectable decode="true"  > 利息算法：   </span>
                        <span class='item_result' selectable decode="true"  >{{ item.result.algorithm }}  </span>
                        
               

                    
                    </div>

                    
                    <p  style="font-weight:600;margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;备注：结果仅供参考。请统一用小数表示，例如年息24，请写0.24。选择年息计算时，会法院惯例，一年计作360天,用年息/天数，转换为日息，再乘以实际天数。选择月息计算时，每月计做天数30天，再乘以实际天数。日息直接按照实际天数计算。</p>
                    
                    <!-- <p>{{inputValue}}</p> -->
                </div>

               
               

                
                    

            </div>   





        </div>
</template>

<script>
var filters = {
    toFix: function (value) {
        return value.toFixed(2)//此处2为保留两位小数
    }
} 

function guid2() {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (S4() + S4()  + S4()  + S4() +  S4() +  S4() + S4() + S4());
}


function isphone() {
	var sUserAgent = navigator.userAgent.toLowerCase();
	var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
	var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
	var bIsMidp = sUserAgent.match(/midp/i) == "midp";
	var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
	var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
	var bIsAndroid = sUserAgent.match(/android/i) == "android";
	var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
	var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid
			|| bIsCE || bIsWM) {
		return true
	} else {
		return false
	}
}

function DateDiff(sDate1, sDate2) {    //sDate1和sDate2是2002-12-18格式  
  var aDate, oDate1, oDate2, iDays
  aDate = sDate1.split("-")
  oDate1 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0])    //转换为12-18-2002格式  
  aDate = sDate2.split("-")
  oDate2 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0])
  iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24) 
     //把相差的毫秒数转换为天数  
  return iDays
}


 import { IncUseNumber,SetMinHeight } from '@/assets/js/cal/cal';  
 import consult from '@/components/ads/consult.vue' 


 

export default {
        name: 'interest2',
        metaInfo: {
            title: '自定义利息计算器', // set a title
            meta: [{                 // set meta
                name: 'keywords',
                content: '利息计算,律师咨询,找律师,司法计算器'
            }],
      
        },
		props: {
            // isPhone: Boolean
        },
        components: { 
            consult
        },
        data() {
			return { 
                inputValue:'',
                date:['',''],
                ratio:'日息',
                s3:'',
                result1:'',
                result2:'',
                interest:'',
                days_mode:'mode_d1',
                screenWidth:window.innerWidth,
                screenHeight:window.innerHeight,
                isPhone:false,
                method_year:'360',
                param:{
                    cond:[
                    
                    ],   
                },
    
                resArr:[],
                isMuti:'no',
                algorithm:'',
              
            }
        },
        // created(){
        //     this.isPhone=isphone()
        // },
        mounted() {

            IncUseNumber('interest2')
            this.isPhone=isphone()
            console.log('this.isPhone:',this.isPhone)
            SetMinHeight()

            


            //  <div id='calbox' :class=" !isPhone? 'function_wrap box':'function_wrap box_mobile' "  
            // :style="'min-height:'+(screenHeight-80)+'px;'   " 




        },
        methods:{
            reset(){
                this.inputValue=''
                this.date=[]
                this.interest=''
                this.param.cond=[]

            },

            
            AddLine(){
                var that=this 
                if(this.$store.state.accountInfo.vip!=1){
                    that.$message({
                        type: 'info',
                        message:'该功能为会员功能',
                        showClose: true,
                        duration:3000,
                    });
                    return
                }

                if(this.param.cond.length<100){
                    let p=new Date()
                    let obj=that.param.cond
                    let date= p.getFullYear() + "/" + (p.getMonth() + 1) + "/" + p.getDate()
                    let t= { amount:0 ,date:  ''  }  // kind:'back'   s1: 'plus'  ,
                    this.param.cond.push(t)
                    // obj.push(t)
                    // that.setData({
                    //     'param.cond':obj
                    // })
                }else{
                    that.$message({
                        type: 'info',
                        message:'超过支持上限',
                        showClose: true,
                        duration:3000,
                    });
                  
                }
            },

            RemoveLine(index){
            
                // let index=e.currentTarget.dataset.ind
                if(this.param.cond.length>=1){
                    // console.log("lenth:",this.data.param.cond.length)
                    let obj=this.param.cond
                    
                    obj.splice(index,1)
                    this.param.cond=obj
                    // this.setData({
                    //     'param.cond':obj
                    // })
                }

            },

            bind_download(){
               
                var that=this
                // if(!this.guid){
                //     this.$message.error('需先计算得出有效结果');
                // }

                if(!this.resArr || this.resArr.length==0){  //!this.data.result.total_lpr
                    that.$message({
                        type: 'info',
                        message:'需要有多付款记录才支持导出报告',
                        showClose: true,
                        duration:3000,
                    });
                    return
                }

                if(this.$store.state.accountInfo.vip!=1){
                    that.$message({
                        type: 'info',
                        message:'该功能为会员功能',
                        showClose: true,
                        duration:3000,
                    });
                    return
                }

                var data= { 
                    
                    pre_filename:this.guid,
                    // algorithm:this.algorithm || []
                    tableData:this.resArr,

                    whattodo: "download_int2",
   
                
                }


    
                

                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let url= this.$root.rootUrl+'mini_app_vip'
                this.axios.post(url,data
                ).then(function (res) {
                    var result=res.data
                    window.console.log(res)
                    if(result.status=='badgate'){
                        that.$message({
                            message: '请先登录哦',
                            type: 'warning'
                        });

                    }else if(result.status=='ok'){
                        that.DownLoad(result.link)
                    }else if(result.status=='fail'){
                        that.$message.error(result.failMsg);
                    }
                    loading.close();
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                    loading.close();
                });


            },

            
            DownLoad(url){
                window.open(url, '_blank');
            },

            newcal(){
                 
                if(!this.inputValue  ){
                    alert('金额得填写哦，整数或小数，不要有逗号哦');
                    return
                }



                if(!this.date[0] || !this.date[1]){
                    alert('起止日期记得选择哦');
                    return
                }

                console.log('this.ratio:',this.ratio)

                if(!this.interest  ){
                    alert('利息记得填写哦，整数或小数，不要有百分号或者逗号哦');
                    return
                }


             




                var isMuti;
                console.log('this.date:',this.date)
                var that=this
                var cond = JSON.parse(JSON.stringify(this.param.cond));

                var tmp1=Date.parse(this.date[0])
                var tmp2=Date.parse(this.date[1])

 

                if(tmp1>=tmp2){
                    alert('开始日期要小于截止日期');
                    return
                }
             
                console.log('tmp1:',tmp1)
                console.log('tmp2:',tmp2)
             
                for(let p of cond){
            

                    p.date=p.date.replace(/\//g, "-")
                    p.timestamp=Date.parse(p.date)

                    if( (!p.amount || p.amount==0) && p.timestamp!=Date.parse(this.date[1])  ){
            
                        that.$message({
                            type: 'info',
                            message:'还款金额不能为0',
                            showClose: true,
                            duration:3000,
                        });
                        return

                        
                    }

                    if(tmp1>p.timestamp){
    
                        that.$message({
                            type: 'info',
                            message: '开始日期要小于还款日期',
                            showClose: true,
                            duration:3000,
                        });
                        return
                    }

                    if(tmp2<p.timestamp){

                        that.$message({
                            type: 'info',
                            message: '还款日期要小于截止日期',
                            showClose: true,
                            duration:3000,
                        });
                        return
                    }

                }

                cond.sort((x,y)=>{
                    return x.timestamp-y.timestamp

                })

                if (cond.length>0){
                 isMuti='yes'
            
                if(  Date.parse(cond[cond.length-1].date)<Date.parse(this.date[1])   ){
                    cond.push({  amount:0 ,date: this.date[1].replace(/\//g, "-")  })
                }

                }else{
                  isMuti='no'
           
                }

                this.isMuti=isMuti
                if(isMuti=='no'){
                    this.bindcalculate()
                }else{
                    this.calclick2(cond)
                }

            },

            calclick2(cond){
                this.s3= DateDiff(this.date[0], this.date[1]);
                if(this.days_mode=='mode_d2'){
                    this.s3++
                }
                var that=this 
                console.log("this.date:",this.date[0])
                let method 
         
                if(that.ratio=='日息'){
                    method='day'
                }else if(that.ratio=='月息'){
                    method='month'
                }else{
                    method='year'
                }

                let data={
                    startDate: this.date[0].replace(/\//g, "-"),  //.replace(/-/g,""),
                    endDate:  this.date[1].replace(/\//g, "-"),   //.replace(/-/g, ""),
                    whattodo:'int2_cal',
                    type: method,//  
                    amount: parseFloat(filters.toFix(parseFloat(this.inputValue))),
                    year: that.method_year,
     
                    days_mode:that.days_mode,
                    cond:cond,
                    ratio:this.interest
                }
                this.axios.post(this.$root.rootUrl+'mini_app',data
                ).then(function (res) {
                
                    if(res.status==200){
                        let result=res.data
                        if(result.status=='badgate'){
                            that.$message({
                                showClose: true,
                                message: '请先登录哦',
                           
                            });
                            return
                        }
             
                        else if(result.status=='ok'){
                            that.resArr=result.data
                            that.guid=guid2()

                        }else if(result.status=='noresult'){
                            that.$message('没有查询到结果');
                   
                        }else if(result.status=='fail'){
                            that.$message(result.failMsg);
                         
                        }

                    }
                      
                    
            
                    
                }).catch(function (error) {
                    window.console.log(error);
                    // loading.close();
                    that.tip='服务器出错，请再次尝试或联系客服'
                    that.$message({
                        message: '查询超时或内部错误',
                        type: 'error'
                    });
                });

            },


        bindcalculate: function () {
            // if(!this.date){
            //     alert('日期记得选择哦');
            // }
         
          
            var t =this.inputValue;
            var xi =this.interest;
    

            // this.s3=(this.date[1]-this.date[0])/86400000;

            this.s3= DateDiff(this.date[0], this.date[1]);
            if(this.days_mode=='mode_d2'){
                this.s3++
            }
            window.console.log(this.s3);

            // var a0, a1, a2, a3, a4, time;
  
            // var  sum;

 

        
            var final_int;   
            let algorithm;
            if(this.ratio=='日息'){
                final_int = parseFloat(xi);
                algorithm=t+'*'+xi+'*'+this.s3 
            }
            else if (this.ratio=='月息'){
                final_int = parseFloat(xi)/30;
                algorithm=t+'*'+xi+'/30'+'*'+this.s3  
            }
            else if (this.ratio=='年息') {
                let year
                if (this.method_year=='360'){
                    final_int = parseFloat(xi) / 360;
                    algorithm=t+'*'+xi+'/360'+'*'+this.s3  
                }else{
                    final_int = parseFloat(xi) / 365;
                    algorithm=t+'*'+xi+'/365'+'*'+this.s3  

                }
               
            }
            this.algorithm=algorithm

       
            var amount1 = filters.toFix(filters.toFix(parseFloat(t)) * this.s3 * final_int);
            var amount2 = filters.toFix(parseFloat(t) + parseFloat(amount1));

    
 
            this.result1=amount1;
            this.result2=amount2;
            this.resArr=[]




        },
        }

       


    }
</script>

<style>
body
{

    background-color: #f0f0f0;
  
} 
.plus_box{
    /* margin-left: auto;
    margin-right: auto; */
  border: 1px dashed #666666;
  width:80%;
  margin-top: 30px;
  
  /* display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: left; */

}



.refund_box{
  /* border: 1rpx solid #da2121; */
  width:100%;
  text-align: left;
  font-size:15px;
  margin-bottom: 6px;
  height: 30px;
  line-height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

}

.newline{
    width:100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    /* border: 1px solid #2187da; */
    height: 40px;
    line-height: 40px;
    padding-bottom:10px;
}

.newline .item_name{
    width:20%;
    text-align: center;
    padding-left: 40px;
    /* border: 1px solid #2187da; */
}

.newline .item_detail{
    width: 30%;
}

.resultbox{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  border: 1px dashed #666666;
  width:100%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
}



.guide{
  /* font-size:22rpx; */
  float: right;
  /* padding-right: 20rpx; */
  text-decoration: underline;
  margin-right: 20px;
  color: rgb(19, 109, 145);
  cursor: pointer;
}

.el-date-editor--date{ 
    max-width: 200px; 
} 
</style>

<style   >
 
.el-date-editor.el-input {
    width: 100% ;
}
.el-date-editor--date {

    max-width: 100%;
}

</style>